import { Component, EventEmitter } from '@angular/core';
import { Modal } from '../modal';

@Component({
  selector: './re-view-image-modal',
  styles: ["\n    .preview-image{width:100%}.modal-title .title-text{max-width:20em;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}\n  "],
  template: "\n    <div class=\"view-image-modal\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"close()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\"><div class=\"title-text\" [attr.title]=\"context?.name\">{{context?.name}}</div></h4></div><div class=\"modal-body\"><img class=\"preview-image img-responsive\" [src]=\"context?.url\" [attr.alt]=\"context?.name\"></div></div>\n  "
})

export class ViewImageModalComponent implements Modal {
  context: any;
  dismiss: EventEmitter<any>;

  close() {
    this.dismiss.next(null);
  }
}
